import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Gateway.css';
import { URL } from '../components/constants'
import bright from '../assets/images/bright.svg'

export default function Gateway({ onLogin }) {
  const [inputText, setInputText] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [focused, setFocused] = useState(false);

  const navigate = useNavigate();

  const handleEnter = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // send JSON with your input text
        body: JSON.stringify({ user_id: inputText.toLowerCase(), password }),
        credentials: 'include', // important: tells the browser to save cookies
      });

      if (response.ok) {
        // 200 response → cookie is automatically stored by the browser
        console.log("Logging in")
        onLogin();          // tell App the user is now logged in
        navigate('/hobbithole');
      } else {
        setError('The path remains closed. Your identity is unknown.');
      }
    } catch (err) {
      console.error(err);
      setError('The web of communication is broken. Attempt again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img
          src={bright}
          alt=""
          className={`hover-image ${focused ? 'glowing' : ''}`}
        />

        <p>
          Speak your name, <i>friend</i>, and enter
        </p>

        <div className="input-stack">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder="bilbo"
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleEnter(); }}
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleEnter(); }}
          />

          <button onClick={handleEnter} disabled={loading}>
            {loading ? 'Logging in...' : 'enter'}
          </button>
        </div>

        {error && <p style={{ color: 'red', fontSize:'18px', fontFamily: 'Georgia' }}>{error}</p>}
      </header>
    </div>
  );
}